import ProprietarStep from "./steps/ProprietarStep";
import ChiriasStep from "./steps/ChiriasStep";
import ImobilStep from "./steps/ImobilStep";
import FinanciarStep from "./steps/FinanciarStep";
import ConditiiStep from "./steps/ConditiiStep";
import PVSetupStep from "./steps/PVSetupStep";
import PVRoomsStep from "./steps/PVRoomsStep";
import PVUtilitiesStep from "./steps/PVUtilitiesStep";
import PreviewStep from "./steps/PreviewStep";
import buildInchirierePDF from "./buildPDF";
import buildInchirierePVPDF from "./buildPVPDF";

const inchiriereConfig = {
  buildPDF: buildInchirierePDF,
  buildPVPDF: buildInchirierePVPDF,
  title: "Contract de Inchiriere Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract valid conform legislatiei din Romania",
  step1Benefit: "Actualizat 2026, conform Codului Civil",
  pdfFilename: "contract-inchiriere.pdf",
  steps: [
    { id: "proprietar", label: "Proprietar", title: "Datele Proprietarului", icon: "\uD83C\uDFE0", component: ProprietarStep },
    { id: "chirias", label: "Chirias", title: "Datele Chiriasului", icon: "\uD83D\uDC64", component: ChiriasStep },
    { id: "imobil", label: "Imobil", title: "Datele Imobilului", icon: "\uD83C\uDFE2", component: ImobilStep },
    { id: "financiar", label: "Financiar", title: "Datele Financiare", icon: "\uD83D\uDCB6", component: FinanciarStep },
    { id: "conditii", label: "Conditii", title: "Conditii Contractuale", icon: "\uD83D\uDCCB", component: ConditiiStep },
    { id: "pvSetup", label: "PV Setup", title: "Proces Verbal — Configurare", icon: "\uD83D\uDCDD", component: PVSetupStep },
    { id: "pvRooms", label: "Inventar", title: "Proces Verbal — Inventar Camere", icon: "\uD83D\uDECB\uFE0F", component: PVRoomsStep, visible: (data) => !!data.pvEnabled },
    { id: "pvUtilities", label: "Contoare", title: "Proces Verbal — Citiri Contoare", icon: "\uD83D\uDD0C", component: PVUtilitiesStep, visible: (data) => !!data.pvEnabled },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "\uD83D\uDCC4", component: PreviewStep },
  ],
  defaultData: {
    proprietarPJ: false,
    proprietarNume: "",
    proprietarCNP: "",
    proprietarCI: "",
    proprietarAdresa: "",
    proprietarFirma: "",
    proprietarCUI: "",
    proprietarRegCom: "",
    proprietarSediu: "",
    proprietarReprezentant: "",
    chiriasPJ: false,
    chiriasNume: "",
    chiriasCNP: "",
    chiriasCI: "",
    chiriasAdresa: "",
    chiriasFirma: "",
    chiriasCUI: "",
    chiriasRegCom: "",
    chiriasSediu: "",
    chiriasReprezentant: "",
    imobilTip: "apartament",
    imobilTipAltul: "",
    imobilAdresa: "",
    imobilSuprafata: "",
    imobilCamere: "",
    imobilEtaj: "",
    chirie: "",
    valuta: "EUR",
    ziuaPlata: "1",
    garantie: "1",
    durata: "12",
    dataInceput: "",
    mobilat: true,
    utilitatiIncluse: false,
    animalePermise: false,
    fumatPermis: false,
    subinchirierePermisa: false,
    pierdereGarantie: false,
    notificareZile: "30",
    penalizareActiva: true,
    penalizare: "0.1",
    nrMaxPersoane: "2",
    zilePlatUtilitati: "15",
    zileNeplatReziliere: "90",
    // PV fields
    pvEnabled: false,
    pvDate: "",
    pvStareGenerala: "buna",
    pvRooms: [],
    pvUtilities: {},
    pvObservatiiGenerale: "",
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "proprietar") {
      if (data.proprietarPJ) {
        if (!data.proprietarFirma.trim() || data.proprietarFirma.trim().length < 2) {
          errors.proprietarFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.proprietarCUI.trim()) {
          errors.proprietarCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.proprietarCUI.trim())) {
          errors.proprietarCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.proprietarSediu.trim()) errors.proprietarSediu = "Sediul social este obligatoriu";
        if (!data.proprietarReprezentant.trim()) {
          errors.proprietarReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.proprietarReprezentant.trim().split(/\s+/).length < 2) {
          errors.proprietarReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.proprietarNume.trim()) {
          errors.proprietarNume = "Numele este obligatoriu";
        } else if (data.proprietarNume.trim().split(/\s+/).length < 2) {
          errors.proprietarNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.proprietarCNP.trim() && !/^\d{13}$/.test(data.proprietarCNP.trim())) {
          errors.proprietarCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.proprietarCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.proprietarCI.trim())) {
          errors.proprietarCI = "Format invalid (ex: RD 123456 sau RD 1234567)";
        }
        if (!data.proprietarAdresa.trim()) errors.proprietarAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "chirias") {
      if (data.chiriasPJ) {
        if (!data.chiriasFirma.trim() || data.chiriasFirma.trim().length < 2) {
          errors.chiriasFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.chiriasCUI.trim()) {
          errors.chiriasCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.chiriasCUI.trim())) {
          errors.chiriasCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.chiriasSediu.trim()) errors.chiriasSediu = "Sediul social este obligatoriu";
        if (!data.chiriasReprezentant.trim()) {
          errors.chiriasReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.chiriasReprezentant.trim().split(/\s+/).length < 2) {
          errors.chiriasReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.chiriasNume.trim()) {
          errors.chiriasNume = "Numele este obligatoriu";
        } else if (data.chiriasNume.trim().split(/\s+/).length < 2) {
          errors.chiriasNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.chiriasCNP.trim() && !/^\d{13}$/.test(data.chiriasCNP.trim())) {
          errors.chiriasCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.chiriasCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.chiriasCI.trim())) {
          errors.chiriasCI = "Format invalid (ex: MZ 654321 sau MZ 6543210)";
        }
        if (!data.chiriasAdresa.trim()) errors.chiriasAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "imobil") {
      if (data.imobilTip === "altul" && (!data.imobilTipAltul || !data.imobilTipAltul.trim())) {
        errors.imobilTipAltul = "Specificati tipul imobilului";
      }
      if (data.imobilTip === "apartament" && !data.imobilCamere) {
        errors.imobilCamere = "Selecteaza numarul de camere";
      }
      if (!data.imobilAdresa.trim()) errors.imobilAdresa = "Adresa imobilului este obligatorie";
      if (!data.imobilSuprafata) {
        errors.imobilSuprafata = "Suprafata este obligatorie";
      } else if (Number(data.imobilSuprafata) <= 0) {
        errors.imobilSuprafata = "Suprafata trebuie sa fie un numar pozitiv";
      }
    }

    if (stepId === "financiar") {
      if (!data.chirie) {
        errors.chirie = "Chiria este obligatorie";
      } else if (Number(data.chirie) <= 0) {
        errors.chirie = "Chiria trebuie sa fie un numar pozitiv";
      }
      if (!data.dataInceput) errors.dataInceput = "Data de inceput este obligatorie";
    }

    return errors;
  },
};

export default inchiriereConfig;
